import { InputStateInterface } from 'common/module/input/state.interface';
import { InputValidatorInterface } from 'common/module/input/validator.interface';

export class InputValidatorPhone implements InputValidatorInterface {
  /**
   * Constructor
   */
  constructor(protected phone: string) {}

  /**
   * @inheritDoc
   */
  public getError(value: string, context: { [key: string]: InputStateInterface }): string {
    // Remove all spaces to check only number
    value = value.replace(/ /g, '');

    return !value.match(/^\+?[\d]{8,15}$/) ? this.phone : '';
  }
}
